import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import toast from 'react-hot-toast';

export const base_url = process.env.REACT_APP_API_URL;

const sportsList = [
  'Football', 'Tennis', 'Cricket', 'Casino'
//    'Horse Racing',
//   'Greyhound Racing', 'Kabaddi', 'I Casino', 'Casino', 'Politics'
];

const UserSportsSetting = () => {
  const { phone } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [sportsSettings, setSportsSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const fetchUsers = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        base_url + `/webapi/admin/getUserStatus/${phone}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      console.log('Response:', response.data);
      if (response.data.settings) {
        setSportsSettings(response.data.settings);
      }
    } catch (err) {
      console.error("Failed to fetch user settings", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

 const toggleSport = (sport) => {
  const updatedValue = !sportsSettings[sport]; // local toggle

  // Update frontend immediately
  setSportsSettings(prev => ({
    ...prev,
    [sport]: updatedValue
  }));

  axios.post(
    base_url + "/webapi/admin/updateUserStatus",
    {
      phone,
      sport
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("admin"),
      }
    }
  )
  .then(() => toast.success('Settings updated successfully.'))
  .catch(() => toast.error('Failed to update settings.'));
};


useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container mt-4">
          <h4 className="mb-4 text-center fw-bold">
            Sport Settings for <span className="text-primary">{phone}</span>
          </h4>

          {loading ? (
            <div className="text-center">Loading...</div>
          ) : (
            <div className="row justify-content-center">
              <div className="col-md-8 col-sm-12">
                <ul className="list-group shadow">
                  {sportsList.map(sport => (
                    <li
                      key={sport}
                      className="list-group-item d-flex justify-content-between align-items-center"
                      style={{
                        padding: '0.75rem 2rem',
                        fontSize: '1rem',
                        transition: 'background 0.2s ease'
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>{sport}</span>
                      <div
                        className="form-check form-switch d-flex align-items-center justify-content-center"
                        style={{ transform: 'scale(1.3)'  }}
                      >
                       <input
                            className="form-check-input custom-switch "
                            type="checkbox"
                            id={`switch-${sport}`}
                            checked={sportsSettings[sport] || false}
                            onChange={() => toggleSport(sport)}
                            style={{
                            cursor: 'pointer',
                            width: '2rem',
                            height: '1rem',
                            marginRight:"5rem",
                            backgroundColor: sportsSettings[sport] ? 'green' : 'red',
                            borderColor: sportsSettings[sport] ? 'green' : 'red',
                            transition: 'background-color 0.3s ease, border-color 0.3s ease',
                            }}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor={`switch-${sport}`}
                          style={{
                            fontWeight: '500',
                            color: sportsSettings[sport] ? '#198754' : '#6c757d'
                          }}
                        >
                          {sportsSettings[sport] ? 'Active' : 'De-Active'}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>

                {/* <div className="text-center mt-4">
                  <button
                    className="btn btn-success px-4 py-2"
                    onClick={handleSave}
                    style={{ fontSize: '1rem', fontWeight: 500 }}
                  >
                    Save Settings
                  </button>
                </div> */}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default UserSportsSetting;
